import {AIS_ROUTES} from 'components/ais/ais.constants';
import {TReferenceResolver} from 'entities/metadata';
import {AIS3_MAIN_PAGE_ENTITY_NAME} from 'pages/ais/ais-main-page/ais-main-page.constants';
import {CONTROL_RATIO_RULES_ENTITY_NAME} from 'shared/constants/urls';

import {
    IDefaultTableStateFlat, TEntity, TOptionsTableType, TOptionsTabsType, ITableEntityData,
} from './data-types';

export const DATA_MODULE = 'DATA_MODULE';

export const DataActions = {
    SET_DATA: 'SET_DATA',
    RESET_DATA: 'RESET_DATA',
    RESET_ALL_DATA_WITH_EXCEPTION: 'RESET_ALL_DATA_WITH_EXCEPTION',
    SET_IS_EDITABLE: 'SET_IS_EDITABLE',
    UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
    RESET_FORM_DATA: 'RESET_FORM_DATA',
    SET_FORM_INSTANCE: 'SET_FORM_INSTANCE',
    SET_INITIAL_FORM_DATA: 'SET_INITIAL_FORM_DATA',
    SET_FILTER_LOADING_STATE: 'SET_FILTER_LOADING_STATE',
    SET_DATA_LOADING_STATE: 'SET_DATA_LOADING_STATE',
    SET_FORM_USED_ADDITIONAL_OPTION_ID: 'SET_FORM_USED_ADDITIONAL_OPTION_ID',
    SET_FORM_USED_ADDITIONAL_OPTIONS: 'SET_FORM_USED_ADDITIONAL_OPTIONS',
    RESET_FORM_USED_ADDITIONAL_OPTIONS: 'RESET_FORM_USED_ADDITIONAL_OPTIONS',
    SET_FORM_MODE: 'SET_FORM_MODE',
    SET_NOTIFICATION_DURATION: 'SET_NOTIFICATION_DURATION',
    RESET_INITIAL_DATA: 'RESET_INITIAL_DATA',
    SET_DOCUMENT_SCANS_DATA: 'SET_DOCUMENTS_SCAN_DATA',
    REMOVE_DOCUMENT_SCANS: 'DELETE_DOCUMENTS_FROM_SCANS',
    SET_SELECTED_SUBSECTION: 'SET_SELECTED_SUBSECTION',
    SET_FILTER: 'SET_FILTER',
};

export const TABS_DEFAULT_DATA: TEntity = {
    id: -1,
};

export const BOOLEAN_MATCH_TABLE: Record<string, string | boolean> = {
    Y: 'N',
    N: 'Y',
    y: 'n',
    n: 'y',
    yes: 'not',
    not: 'yes',
    true: 'false',
    undefined: 'Y',
    false: 'true',
    0: '1',
    1: '0',
    null: 'Y',
    '': 'Y',
};

export const ALLOWED_BOOL_VALUES: Record<string, boolean> = {
    y: true,
    true: true,
    n: false,
    false: false,
    undefined: false,
    Y: true,
    N: false,
    0: false,
    1: true,
};

export const BOOL_VALUE_WITH_TABLE: Record<any, string> = {
    true: 'Y',
    false: 'N',
    undefined: 'N',
    null: 'N',
};

export const REFERENCE_RESOLVERS: Record<string, TReferenceResolver> = {};

export const DATA_RESOLVERS: Record<string, (referenceUrl: TEntity) => TEntity> = {};

export enum ERequestGrade {
    DISLIKE = 0,
    LIKE = 1,
}

export const DEFAULT_TABLE_DATA: ITableEntityData = {
    page: 0,
    limit: 10,
    offset: 0,
};

export const DEFAULT_TABLE_STATE: IDefaultTableStateFlat = {
    paginationPageSize: 10,
    paginationCurrent: 1,
};

export const DEFAULT_SEARCH_PARAMS = {
    search: '',
};

export const OPTIONS_TABLE_DEFAULT: TOptionsTableType = {
    useContext: false,
    useSearch: false,
};

export const OPTIONS_TABS_DEFAULT: TOptionsTabsType = {
    useContext: false,
};

/**
* Список страниц, для которых при смене контекста повторный запрос на данные не уходит автоматически.
* Если такой запрос нужен, то его следует добавить в useEffect компонента страницы, который зависит от данных контекста
*/
export const MANUALLY_UPDATING_CONTEXT_PAGES = [
    AIS3_MAIN_PAGE_ENTITY_NAME,
    AIS_ROUTES.DOCUMENTS_INTERFACE,
    AIS_ROUTES.DOCUMENTS_REGISTER,
    AIS_ROUTES.TAX_FORECAST,
    AIS_ROUTES.ORGANIZATION_STRUCTURE_V5,
    CONTROL_RATIO_RULES_ENTITY_NAME,
    AIS_ROUTES.RISKS_DOCUMENTS_MAPPING,
];

// Сущности для перезагрузки контекста и таблицы
export const RESET_CONTEXT_ENTITIES: string[] = [
    AIS_ROUTES.FORECAST_COMMENTS,
    AIS_ROUTES.TAX_FORECAST,
    AIS_ROUTES.COMMENTS_REQUEST_RESULT_ND,
];

// todo: фиксит баг из задачи TAXMONSUPP-3071. В дальнейшем решить проблему с отправкой контекста
export const ENTITIES_FOR_REQUEST_WITH_CONTEXT = [
    'accounting.transactions.and.trialbalance',
];
